export default __webpack_public_path__ + "static/media/fb_help2.586d1b06.svg";